const roleAccess = {
  1: ['Home', 'Workspace', 'Drive', 'Paybooks', 'Engagements', 'Chat', 'API Client', 'Calendar', 'Organization', 'Customers', 'Admin Console'],
  2: ['Home', 'Workspace', 'Drive', 'Paybooks', 'Engagements', 'Chat', 'API Client', 'Calendar', 'Organization', 'Customers', 'Admin Console'],
  3: ['Home', 'Workspace', 'Drive', 'Paybooks', 'Engagements', 'Chat', 'Calendar', 'Organization', 'Customers', 'Admin Console'],
  4: ['Home', 'Workspace', 'Drive', 'Paybooks', 'Engagements', 'Chat', 'API Client', 'Calendar'],
  5: ['Home', 'Workspace', 'Drive', 'Paybooks', 'Engagements', 'Chat', 'Calendar', 'Organization'],
  6: ['Home', 'Workspace', 'Drive', 'Paybooks', 'Engagements', 'Chat', 'Calendar'],
  7: ['Home', 'Workspace', 'Drive', 'Paybooks', 'Engagements', 'Chat', 'API Client', 'Calendar'],
  8: ['Home', 'Workspace', 'Drive', 'Paybooks', 'Engagements', 'Chat', 'API Client', 'Calendar'],
  9: ['Home', 'Workspace', 'Drive', 'Paybooks', 'Engagements', 'Chat', 'API Client', 'Calendar']
};

const menu = [
  {
    key: 'home',
    link: '/home/feed',
    icon: 'HomeOutlined',
    text: 'Home',
    active: false
  },
  {
    key: 'workspaces',
    link: '/workspaces',
    icon: 'WorkspaceOutlined',
    text: 'Workspace',
    active: true
  },
  {
    key: 'dms',
    link: '/dms/mydrive',
    icon: 'DocumentsOutlined',
    text: 'Drive',
    active: true
  },
  {
    key: 'paybooks',
    link: '/paybooks/dashboard',
    icon: 'InvoicesOutlined',
    text: 'Paybooks',
    condition: 'workspace',
    active: false
  },
  {
    key: 'engagements',
    link: '/engagements/meetings',
    icon: 'EngagementsOutlined',
    text: 'Engagements',
    active: false
  },
  {
    key: 'chat',
    link: '/chat',
    icon: 'ChatOutlined',
    text: 'Chat',
    active: false
  },
  {
    key: 'apiclient',
    link: '/apiclient/environments',
    icon: 'EnvOutlined',
    text: 'API Client',
    condition: 'workspace',
    active: false
  },
 
  {
    key: 'calendar',
    link: '/calendar/dashboard',
    icon: 'CalendarOutlined',
    text: 'Calendar',
    active: false
  },
  {
    key: 'org',
    link: '/org/employees',
    icon: 'OrgOutlined',
    text: 'Organization',
    active: true
  },
  {
    key: 'customers',
    link: '/customers/dashboard',
    icon: 'ClientsOutlined',
    text: 'Customers',
    active: true
  },
  {
    key: 'admin',
    link: '/admin/settings',
    icon: 'SettingsOutlined',
    text: 'Admin Console',
    active: true
  }
];

function getMenuForRoles(user) {
  const accessibleMenus = new Set();

  user?.roles?.forEach(roleId => {
    const accessibleItems = roleAccess[roleId] || [];
    accessibleItems?.forEach(item => accessibleMenus?.add(item));
  });

  return menu.filter(menuItem => menuItem.active && accessibleMenus.has(menuItem.text));
}

export { getMenuForRoles };
